import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
};
/** Renders an inline loading indicator with an accessible label. */
export function Spinner({ label = 'Loading…', size = '1.25rem', className, }) {
    return (_jsxs("span", { role: "status", "aria-live": "polite", className: className, style: { display: 'inline-flex' }, children: [_jsx("span", { "aria-hidden": "true", style: {
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    border: '0.15em solid #d0d7de',
                    borderTopColor: '#0969da',
                    display: 'inline-block',
                } }), _jsx("span", { style: visuallyHidden, children: label })] }));
}
//# sourceMappingURL=Spinner.js.map